//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";

import "./FilterWebinarType.style"

class FilterWebinarType extends PolymerElement {
    static get template() {
        return html `
        <style include="filter-webinar-type-style"></style>
        <div class="filter-webinar-status-container">
            <h2>Berdasarkan Tipe Webinar</h2>
            <hr>
            <div class="webinar-status-list-container">
                <dom-repeat items="{{webinarTypeListData}}" as="webinarStatusItem">
                    <template>
                        <div class="item-webinar-status-container">
                            <label>
                                <dom-if if="{{_isLocalStorage(webinarStatusItem, isTicked)}}">
                                    <template>
                                        <input type="radio" name="webinarTypeVal" value="{{webinarStatusItem.value}}" on-click="_chooseWebinarStatus" checked>
                                        {{webinarStatusItem.name}}
                                    </template>
                                </dom-if>

                                <dom-if if="{{!_isLocalStorage(webinarStatusItem, isTicked)}}">
                                    <template>
                                        <input type="radio" name="webinarTypeVal" value="{{webinarStatusItem.value}}" on-click="_chooseWebinarStatus">
                                        {{webinarStatusItem.name}}
                                    </template>
                                </dom-if>
                            <label>
                        </div>
                    <template>
                </dom-repeat>
            </div>
        </div>
        `;
    }

    static get properties() {
        return {
            isTicked: {
                type: Boolean,
                value: true
            },

            webinarTypeListData: {
                type: Array,
                value() {
                    return [{
                            "name": "Semua",
                            "value": "all"
                        },
                        {
                            "name": "Webinar",
                            "value": "single"
                        },
                        {
                            "name": "Series Webinar",
                            "value": "series"
                        }
                    ];
                }
            },
        }
    }

    ready() {
        super.ready()
    }

    _isLocalStorage(webinarStatusItem, isTicked) {
        let currentUrl = (new URL(document.location)).searchParams;
        let webinarType = currentUrl.get('webinar_type')

        if (webinarStatusItem.value == webinarType) {
            return isTicked
       } else {
            return webinarStatusItem.value == "all"
       }
    }

    _chooseWebinarStatus(e) {
        var selected_radio = e.target.value
        let currentUrl = (new URL(document.location)).searchParams;
        var queryParams = new URLSearchParams(window.location.search);
        let webinarType = currentUrl.get('webinar_type') 

        if (selected_radio == webinarType) {
            return window.stop()

        } else {
            queryParams.set("webinar_type", selected_radio);
            queryParams.set("page", 1);
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let multipleParams = newUrlParam
            return window.location = multipleParams

        }
    }
}
customElements.define("filter-webinar-type", FilterWebinarType);
